import { useEffect, useState } from 'react'
import { Permissions } from '../../../types/user-types'
import useUser from '../../hooks/use-user'
import { can, isCouncilUserOrAdmin } from '../../services/user-utils'
import SelectRegionModal from './select-region-modal'
import DashboardSearch from '../../components/dashboard/search/'
import { usePageState } from '../../context/page-context'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonsContainer, Card, ContentContainer, Heading, TabbedContent } from '@msaf/core-react'

export default function Dashboard() {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const { user } = useUser()
  const navigate = useNavigate()

  const { setPageState } = usePageState()

  useEffect(() => {
    setPageState({
      heading: 'Dashboard',
    })

    return () => setPageState({})
  }, [setPageState])

  const onClickHandlerForUser = () => {
    // Sysadmin can select from any region show modal
    if (can(user, Permissions.MAINTAIN_ALL_USERS)) {
      setModalIsOpen(true)
    } else if (isCouncilUserOrAdmin(user) === false) {
      // If can edit and is not council must be a driller
      // Show the modal and restrict regions available to the ones appropriate to this user.
      setModalIsOpen(true)
    } else {
      navigate('/wells/new/edit/setup')
    }
  }

  const tabs = [
    {
      label: 'Assigned wells',
      tabContent: (
        <DashboardSearch
          noResultsMessage='No well records have been assigned'
          searchType='search-assigned-well-dashboard'
        />
      ),
    },
    {
      label: 'Created wells',
      tabContent: (
        <DashboardSearch noResultsMessage='No well records have been created' searchType='search-well-dashboard' />
      ),
    },
  ]
  return (
    <ContentContainer>
      <ButtonsContainer containerStyle='full-width'>
        {/* Only show the add new well button if user has create well permission */}
        {can(user, [Permissions.CREATE_WELL, Permissions.CREATE_WELL_UNSCOPED]) && (
          <Button
            size='large'
            icon='new'
            iconAlignment='left'
            label='Create new well record'
            onClick={() => onClickHandlerForUser()}
          />
        )}
        {can(user, Permissions.VIEW_WELL) && (
          <Button
            size='large'
            icon='map-pin-solid'
            iconAlignment='left'
            label='Search for wells on a map'
            onClick={() => navigate('/wells/map')}
          />
        )}
        <SelectRegionModal modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />
      </ButtonsContainer>
      {can(user, [Permissions.EDIT_WELL, Permissions.EDIT_WELL_UNSCOPED]) && (
        <>
          <Heading level={2}>My wells</Heading>
          <Card isFullWidth hasTabbedContent>
            <TabbedContent tabs={tabs} borderBottomStyle='shadow' includeHorizontalPadding ariaLabel='My wells' />
          </Card>
        </>
      )}
    </ContentContainer>
  )
}
